<template>
    <div class="shop-area mb-20">
        <div class="container">
            <div class="row">
                <!-- shop sidebar area start -->
                <shop-sidebar-area></shop-sidebar-area>
                <!-- shop sidebar area end -->
                <div class="col-xl-9 col-lg-8">
                    <div class="shop-banner mb-30">
                        <div class="banner-image">
                            <img class="banner-l" :src="slbanner" alt="">
                            <img class="banner-sm" :src="slbannersm" alt="">
                            <div class="banner-content text-center">
                                <p class="banner-text mb-30">Hurry Up! <br> Free Shipping All Order Over $99</p>
                                <router-link href="/shop" class="st-btn-d b-radius">Discover now</router-link>
                            </div>
                        </div>
                    </div>

                    <div class="product-lists-top">
                        <div class="product__filter-wrap">
                            <div class="row align-items-center">
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                                    <div class="product__filter d-sm-flex align-items-center">
                                        <div class="product__col">
                                            <ul class="nav nav-tabs" id="myTab" role="tablist">
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link active" id="FourCol-tab"
                                                        data-bs-toggle="tab" data-bs-target="#FourCol" type="button"
                                                        role="tab" aria-controls="FourCol" aria-selected="true">
                                                        <i class="fas fa-th"></i>
                                                    </button>
                                                </li>
                                                <li class="nav-item" role="presentation">
                                                    <button class="nav-link" id="FiveCol-tab" data-bs-toggle="tab"
                                                        data-bs-target="#FiveCol" type="button" role="tab"
                                                        aria-controls="FiveCol" aria-selected="false">
                                                        <i class="fas fa-list"></i>
                                                    </button>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="product__result pl-60">
                                            <p> Showing 1–{{ product_data.slice(startIndex, endIndex).length }} of {{
                                                product_data.length }} results</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
                                    <div class="product__filter-right d-flex align-items-center justify-content-md-end">
                                        <div class="product__sorting product__show-position ml-20">
                                            <ui-nice-select :options="[
                                                { value: 'default', text: 'Default Sorting' },
                                                { value: 'high', text: 'Low to Hight' },
                                                { value: 'low', text: 'High to Low' },
                                                { value: 'new', text: 'New Added' },
                                                { value: 'sale', text: 'On Sale' },
                                            ]" name="Select Shorting" :default-current="0"
                                                @onChange="store.handleSelectFilter" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="product_data.length === 0" class="cartmini__empty text-center mt-80 mb-80">
                        <img src="/images/product/empty-cart.png" alt="empty-cart-img" />
                        <h4>Sorry! Couldn't find the product you were looking For!!!</h4>
                        <p>Please check if you have misspelt something or try searching with other words.</p>
                        <router-link href="/shop" class="cart-btn">Continue Shopping</router-link>
                    </div>

                    <div v-else>

                        <div class="tab-content" id="productGridTabContent">
                            <div class="tab-pane fade  show active" id="FourCol" role="tabpanel"
                                aria-labelledby="FourCol-tab">
                                <div class="tp-wrapper">
                                    <div class="row g-0">
                                        <div v-for="item in filteredProductsItems.slice(startIndex, endIndex)"
                                            :key="item.id" class="col-lg-3 col-md-4 col-sm-6">
                                            <product-single :product="item" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="tab-pane fade" id="FiveCol" role="tabpanel" aria-labelledby="FiveCol-tab">
                                <div class="tp-wrapper-2">
                                    <product-list-item v-for="item in filteredProductsItems.slice(startIndex, endIndex)"
                                        :key="item.id" :product="item" />
                                </div>
                            </div>
                        </div>
                        <div class="tp-pagination text-center">
                            <div class="row">
                                <div class="col-xl-12">
                                    <div class="basic-pagination pt-30 pb-30">
                                        <ui-pagination :items-per-page="8" :data="filteredProductsItems"
                                            @handle-paginate="handlePagination" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import slbanner from '@/assets/images/banner/sl-banner.jpg'
import slbannersm from '@/assets/images/banner/sl-banner-sm.png'
import ShopSidebarArea from '@/components/shop/sidebar/shop-sidebar-area.vue'
import ProductSingle from '@/components/product/product-single-3.vue'
import UiPagination from '@/components/ui/pagination.vue'
import ProductListItem from '@/components/product/product-list-item.vue'
// eslint-disable-next-line no-unused-vars
//import product_data from "@/data/product-data";
import { useProductFilterStore } from "@/stores/useProductFilterStore"
import { useRoute } from 'vue-router'

export default {
    name: "HeaderOne",
    components: {
        ShopSidebarArea,
        ProductSingle,
        ProductListItem,
        UiPagination
    },
    data() {
        const store = useProductFilterStore()
        return {
            slbanner,
            slbannersm,
            store,
            cate_menu: false,
            isSidebarOpen: false,
            category_data: [],
            product_data: [],
            searchText: '',
            category_value: '',
            category_options: [],
            filteredProductsItems: [],
            startIndex: 0,
            endIndex: 8,
        }
    },
    methods: {
        async fetchProducts() {
            try {
                const response = await this.$axios.get('/available-products')
                this.product_data = response.data
                //console.log(this.product_data);
                // Default to the first 8 items
                this.filteredProductsItems = this.product_data
            } catch (error) {
                console.error("Error fetching categories:", error)
            }
        },

        async fetchCategories() {
            try {
                const response = await this.$axios.get('/top-categories')
                this.category_data = response.data.rows
                console.log(response.data)
                this.category_options = this.category_data.map(item => ({
                    value: item.cat_id,
                    text: item.cat_name,
                }))
                this.category_options.unshift({ value: "all", text: "All Category" })
            } catch (error) {
                console.error("Error fetching categories:", error)
            }
        },
        renderCategoryName(name) {
            return name.replace('&', '<br/> &')
        },
        isLastItem(index) {
            return index === this.category_data.length - 1
        },
        formatUrl(slug) {
            return slug.replace(/\s+/g, '-').toLowerCase()
        },
        handlePagination(data, start, end) {
            this.startIndex = start // Update the indices for current page
            this.endIndex = end
        }
    },
    mounted() {
        this.fetchProducts()
        this.fetchCategories()
        this.$watch(
            () => useRoute().query || useRoute().params,
            () => {
                this.startIndex = 0
                this.endIndex = this.store.filteredProducts && this.store.filteredProducts.length > 8 ? 8 : this.store.filteredProducts.length
            }
        )
    }
}
</script>

<style scoped>
/* Add styles for Home page */
.banner-image .banner-sm {
    position: absolute;
    right: 22%;
    top: 50%;
    transform: translateY(-50%);
}
</style>
